import React, { Component } from "react";
import "./cliente.scss";
import renderHTML from "react-render-html";
import Modal from "react-responsive-modal";
import IconHome from '../../../assets/images/icons8-home.svg';

class Cliente extends Component {
  constructor(props) {
    super(props);
    this.state = {
      image: <img src={ IconHome } alt="Foto" />,
      show: false
    };
  }

  componentDidMount() {
    if (this.props.favorito) {
      if (this.props.favorito.favorite.images && this.props.favorito.favorite.images.length > 0) {
        this.setState({
          image: (
            <img
              className="Favoritoimg"
              src={this.props.favorito.favorite.images[0].url}
              alt="Foto"
            />
          )
        });
      }
    }
  }

  closeModal = () => {
    this.setState({ show: false });
  };

  getDescricaoNegotiation = (negotiation) => {
    if (negotiation === "venda") {
      return "Venda";
    }
    switch (negotiation) {
      case 'venda':
        return 'Venda';
      case 'locacao':
        return 'Locação';
      case 'venda_locacao':
        return 'Venda e Locação';

      default:
        return negotiation;
    }
  }
  render() {
    let { image, show } = this.state;
    let favorito = this.props.favorito;

    return (
      <>
        <tr>
          <td className="ClientDesktop">
            <div>
              <details>
                <summary>{ this.props.nome }</summary>

                <div className="ClientDetails">
                  <div>
                    <a href={`tel:${this.props.telefone}`}>
                      <img alt={ this.props.telefone } src="https://img.icons8.com/ios-filled/24/000000/phone.png"/>
                      { this.props.telefone }
                    </a>
                  </div>

                  <div>
                    <a href={`mailto:${this.props.email}`}>
                      <img alt={ this.props.email } src="https://img.icons8.com/material/24/000000/important-mail.png"/>
                      { this.props.email }
                    </a>
                  </div>

                  <button onClick={() => this.setState({ show: true })}>{ image }</button>

                  <Modal open={show} onClose={this.closeModal} little>
                    <div className="panel panel-success panel-venal">
                      <div className="panel-heading">Informações do Imóvel</div>
                      <div className="panel-body">
                        {
                          favorito && (
                            <>
                              <div className="tipoimv">{this.getDescricaoNegotiation(favorito.favorite.negotiation)}</div>
                              <div>{favorito.favorite.categories}</div>
                              { renderHTML(favorito.html) }
                            </>
                          )
                        }
                      </div>
                    </div>
                  </Modal>
                </div>
              </details>
            </div>
          </td>

          <td className="ClientMobile">
            <a href={`tel:${this.props.telefone}`}>
              <img alt={ this.props.telefone } src="https://img.icons8.com/ios-filled/24/000000/phone.png"/>
              { this.props.telefone }
            </a>
          </td>

          <td className="ClientMobile">
            <a href={`mailto:${this.props.email}`}>
              <img alt={ this.props.email } src="https://img.icons8.com/material/24/000000/important-mail.png"/>
              { this.props.email }
            </a>
          </td>

          {
            // eslint-disable-next-line no-restricted-globals
            (location.pathname !== '/') && (
              <td className="ClientMobile" style={{
                width: '20px'
              }}>
                <button className="ButtonIconHome" onClick={() => this.setState({ show: true })}>
                  <img src={IconHome} alt="Ver detalhes" />
                </button>
              </td>
            )
          }
        </tr>
      </>
    )
  }
}

export default Cliente;
